import { TEST_CONFIG } from 'js/ab_tests/tests/nav_impact_stats_2026_q3_v1';

import { ARMS } from './nav_impact_stats_arms';

export type Arm =
  | 'control'
  | 'v1_delta_chips'
  | 'v2_plain_counts'
  | 'v3_plain_counts_alt'
  | 'v4_trend_icons'
  | 'qa_sink_delta'
  | 'qa_sink_icons';

export type ResolvedArm = Arm | undefined;

export type StatStyle = 'none' | 'plain' | 'delta_chip' | 'trend_icon';
export type StatLayout = 'stacked' | 'inline';

export interface NavImpactSurfaces {
  statStyle: StatStyle;
  statLayout: StatLayout;
}

export const CONTROL: NavImpactSurfaces = {
  statStyle: 'none',
  statLayout: 'stacked',
};

export function resolveNavImpactStats(
  arm: string | null | undefined,
): NavImpactSurfaces {
  const spec = arm == null ? undefined : ARMS[arm as Arm];
  return { ...CONTROL, ...(spec ? spec() : {}) };
}

export function impressionExtra(
  arm: string | null | undefined,
): Record<string, unknown> {
  const isActive: boolean = TEST_CONFIG.active as boolean;
  return {
    autotest_bucket: arm ?? 'control',
    ...(isActive && { autotest: 'nav_impact_stats_2026_q3_v1' }),
  };
}
